import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Button,
  Grid,
  FormControl,
  Select as MuiSelect,
  TextField,
  Autocomplete,
  Switch,
  Tooltip,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import InputAdornment from "@mui/material/InputAdornment";
import { Dayjs } from "dayjs";
import AddCoverageClause from "./AddCoverageClause";
import CONSTANTS, {
  ADD_OPTIONS_UNDERWRITER,
  GENERATE_ENUMS,
  INSURANCE_COMPANIES_FORM_ID,
  PREVIEW_ENUMS,
  PRODUCT_CAVORAGES_LIMITIFANY_FORM_ID,
  PROPOSAL_STATUS,
  Proposal_Specific_Coverages_LimitIfany,
  handleStepStatus,
} from "../constants/constants";
import {
  fetchRuntimeFormData,
  filterRuntimeFormData,
  multiFilterRuntimeFormData,
  patchFormData,
} from "../services/FormService";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useDispatch, useSelector } from "react-redux";
import { pushNotification, setProposalData } from "../redux/actions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import RFQPreview from "./RFQPreview";
import QCRPreview from "./QCRPreview";
import { Box } from "@mui/material";
import GenerateRFQQCR from "./GenerateRFQQCR";
import Lottie from "lottie-react";
import DotLoader from "../animations/DotLoader.json";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Drawer from "@mui/material/Drawer";
import CommentsKeyInsights from "./CommentsKeyInsights";
import { useReactToPrint } from "react-to-print";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DeleteIcon from "@mui/icons-material/Delete";
import Colors from "../theme/colors.json";
import { useNavigate } from "react-router-dom";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import BusinessIcon from "@mui/icons-material/Business";
import SaveIcon from "@mui/icons-material/Save";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

const useStyles = makeStyles((theme) => ({
  underwriterContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  tableContainer: {
    // overflowX: "auto",
    width: "100%",
    // maxHeight: 570,
    position: "relative",
    "@media (min-width: 2000px)": {
      padding: "1.7%  2% 0% 2%",
    },
    "@media (min-width: 1500px) and (max-width: 2000px)": {
      padding: "1.7%  2% 0% 2%",
    },
    "@media (min-width: 1000px) and (max-width: 1500px)": {
      padding: "1.7%  2% 0% 2%",
    },
    "@media (min-width: 600px) and (max-width: 1000px)": {
      padding: "2%  2% 0% 2%",
    },
    "@media (max-width: 600px)": {
      padding: "5%  2% 0% 2%",
    },
  },
  table: {
    minWidth: 650,
    borderCollapse: "initial",
    // margin: "auto",
    marginTop: theme.spacing(1),
    background: Colors.WHITE_BACKGROUND,
  },
  th: {
    border: "1px solid #ddd",
    minWidth: 200,
  },
  td: {
    border: "1px solid #ddd",
    padding: theme.spacing(1),
    minWidth: 350,
  },
  select: {
    width: "100%",
    fontSize: theme.fontSizes.SMALL,
    // height: "1.875rem !important",
  },
  addButton: {
    // marginTop: theme.spacing(2),
    background: Colors.WHITE_BACKGROUND,
    textTransform: "capitalize",
  },

  btnContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 20,
    flexWrap: "wrap",

    position: "sticky",
    bottom: "0",
    marginBottom: "1%",
    marginTop: "1%",
    padding: "0.5%",
    backgroundColor: Colors.WHITE_BACKGROUND,
    width: "96%",
    borderRadius: 5,
    zIndex: 2,
    "&:hover": {
      backgroundColor: Colors.INSUR_BG,
      borderRadius: 0,
    },
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  multiSelect: {
    width: "100%",
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
  },
  dateConatiner: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  inputStylesDate: {
    fontSize: theme.fontSizes.SMALL,
  },
  textFieldStyles: {
    fontSize: theme.fontSizes.SMALL,
    // height: 30,
  },
  firstColumn: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    backgroundColor: "#fff", // Change this to your first column background color
    border: "1px solid #ddd", // Ensure separation from other columns
  },
  customDialog: {
    // zIndex: 10000,
    "& .MuiDialog-paper": {
      maxWidth: "unset",
    },
  },
  loader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center !important",
    alignItems: "center !important",
  },
  drawerBtn: {
    position: "fixed",
    right: 0,
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "1vw 0vw 0vw 1vw",
    zIndex: 1,
    width: "1.3rem",
    top: 40,
  },
  drawerIcon: {
    color: "#FFFFFF",
  },
  flexRowDrawerBtns: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "45vw",
    gap: "10%",
  },
  underwriterPanelActions: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  underwriterPanelActionsHeading: {
    fontSize: "1.3rem",
    fontWeight: 600,
    // color: theme.palette.primary.main,
    textDecoration: "underline",
  },
  deleteTableCell: {
    border: "1px solid #ddd",
    padding: theme.spacing(1),
  },
  underwriterDetailsHeadingText: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    fontSize: "1.3rem",
    fontWeight: 600,
    color: theme.palette.secondary.main,
  },
  previewButton: {
    marginTop: theme.spacing(2),
    background: theme.palette.primary.main,
    textTransform: "capitalize",
  },
  saveButton: {
    marginTop: theme.spacing(2),
    textTransform: "capitalize",
  },
  underwriterDrawer: {
    // zIndex: 9999,
  },
  commonBtnStyles: {
    background: Colors.WHITE_BACKGROUND,
    textTransform: "capitalize",
  },
  previewDialogHeading: {
    background: Colors.INSUR_BG,
    m: 0,
    padding: "0.4rem",
  },
  previewCloseBtn: {
    position: "absolute",
    right: 8,
    top: 7,
    color: theme.palette.grey[500],
  },
  autocompleteInputStyle: {
    fontSize: theme.fontSizes.SMALL,
    // height: "0.063rem !important",
  },
  gstSelect: {
    fontSize: theme.fontSizes.SMALL,
  },
  flexColumnPremiumLabels: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  insuredNameCell: {
    border: "1px solid #ddd",
    minWidth: 200,
    padding: "0 1rem 0 1rem",
    fontSize: theme.fontSizes.MEDIUM,
  },
  tableContainerStyles: {
    "&::-webkit-scrollbar": {
      width: "0.5rem",
      height: "0.5rem", // Initially hide the scrollbar
    },

    "&:hover": {
      "&::-webkit-scrollbar": {
        width: "0.5rem",
        height: "0.5rem", // Adjust the width on hover
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: Colors.GRAY,
        borderRadius: 7,
      },
    },
    maxHeight: "80vh",
    // overflowY: "auto",
    width: "100%",
  },
  backButton: {
    // marginTop: theme.spacing(2),
    // background: Colors.WHITE_BACKGROUND,
    textTransform: "capitalize",
    float: "left",
  },
  stickyHead: {
    position: "sticky",
    top: 0,
    zIndex: 2,

    "& .MuiTableCell-root": {
      backgroundColor: theme.palette.background.paper,
    },
  },
  fixedColumn: {
    position: "sticky",
    left: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: 1,
    border: "1px solid #ddd",
  },
  stickyHeadColumn: {
    position: "sticky",
    left: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: 3,
    border: "1px solid #ddd",
  },
  emptyCell: {
    border: "1px solid #ddd",
  },
}));

const autoCompleteListStyles = {
  width: 450,
};

const animationStyle = {
  height: "30vh",
};

const UnderwriterDetails = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { proposalDataRedux } = useSelector((state: any) => ({
    proposalDataRedux: state.proposalData,
  }));

  const [loading, setLoading] = useState(false);

  const [selectedColumns, setSelectedColumns] = useState<any>([]);

  const [rfqDate, setRfqDate] = React.useState<Dayjs | null>(null);
  const [qcrDate, setQcrDate] = React.useState<Dayjs | null>(null);

  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [openAddNewCoverage, setOpenAddNewCoverage] = React.useState(false);
  const [addOption, setAddOption] = useState("");

  const [coverages, setCoverages] = useState<string[]>([]);
  const [limitIfAny, setLimitIfAny] = useState<string[]>([]);

  const [refresh, setRefresh] = useState(false);

  const [tempCoverageClauseList, setTempCoverageClauseList] = useState([]);
  const [tempLimitIfAnyList, setTempLimitIfAnyList] = useState([]);

  const [disableGenerateRfq, setDisableGenerateRfq] = useState(false);

  const [isCurrentPolicy, setIsCurrentPolicy] = useState<any>(true);

  const [preview, setPreview] = useState("");

  const [openAnchor, setOpenAnchor] = useState(false);
  const [commentsKeyInsights, setCommentsKeyInsights] = useState("");

  const [disableDownload, setDisableDownload] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);

  const [gstPercentage, setGstPercentage] = useState(18);

  const [isStampDuty, setIsStampDuty] = useState(false);

  const handleClickOpenAnchor = () => {
    setOpenAnchor((prevState) => !prevState);
  };

  const handleClickCloseAnchor = () => {
    setOpenAnchor(false);
  };

  const handlePreviewDownload = () => {
    if (preview === PREVIEW_ENUMS.PREVIEW_RFQ) {
      handleDownloadPDF();
    } else {
      handleDownloadPDFQcr();
    }
  };

  //code for rfq and qcr preview dialog
  const [openPreview, setOpenPreview] = React.useState(false);

  const handleClickOpenPreview = () => {
    setOpenPreview(true);
  };
  const handleClosePreview = () => {
    setOpenPreview(false);
  };

  const handlePreviewButtonClick = (value) => {
    handleClickCloseAnchor();
    setPreview(value);
    handleClickOpenPreview();
    const isRFQGenerated =
      proposalDataRedux?.formData?.proposalStatus ===
      PROPOSAL_STATUS.RFQ_GENERATED;
    const isQCRGenerated =
      proposalDataRedux?.formData?.proposalStatus ===
      PROPOSAL_STATUS.QCR_GENERATED;

    if (
      (value === PREVIEW_ENUMS.PREVIEW_RFQ && !isRFQGenerated) ||
      (value === PREVIEW_ENUMS.PREVIEW_QCR && !isQCRGenerated)
    ) {
      const newStatus =
        value === PREVIEW_ENUMS.PREVIEW_RFQ
          ? PROPOSAL_STATUS.RFQ_GENERATED
          : PROPOSAL_STATUS.QCR_GENERATED;

      handleStatusChange(
        handleStepStatus(proposalDataRedux?.formData?.proposalStatus, newStatus)
      );
    }
  };
  // end

  //code for rfq and qcr generate
  const [generate, setGenerate] = useState("");
  const [openGenerate, setOpenGenerate] = useState(false);

  const handleGenerateButtonClick = (value) => {
    setGenerate(value);
    handleClickOpenGenerate();
  };

  const handleClickOpenGenerate = () => {
    setOpenGenerate(true);
  };
  const handleCloseGenerate = () => {
    setOpenGenerate(false);
  };

  //end

  //code for qcr preview dialog
  const qcrContentRef = useRef(null); // Create a reference to the content container

  const handleDownloadPDFQcr = () => {
    // setDisableDownload(true);
    // const content = qcrContentRef.current; // Access the content using the ref

    // // Configuration for html2pdf
    // const opt = {
    //   margin: 10,
    //   filename: `QCR-${proposalDataRedux?.id}(${proposalDataRedux?.formData?.productTitle})`,
    //   image: { type: "jpeg", quality: 0.98 },
    //   html2canvas: { scale: 2 },
    //   jsPDF: {
    //     unit: "mm",
    //     format: "a3",
    //     orientation: "portrait",
    //   },
    //   pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    // };

    // // Generate PDF from the content
    // html2pdf().from(content).set(opt).save();
    // setDisableDownload(false);
    printQcrData();
    setDisableDownload(false);
  };
  const printQcrData = useReactToPrint({
    content: () => qcrContentRef.current,
    documentTitle: "QCR",
  });

  //end

  //code for rfq preview dialog
  const rfqContentRef = useRef(null); // Create a reference to the content container

  const handleDownloadPDF = () => {
    setDisableDownload(true);
    // const content = rfqContentRef.current; // Access the content using the ref

    // // Configuration for html2pdf
    // const opt = {
    //   margin: 10,
    //   filename: `RFQ-${proposalDataRedux?.id}(${proposalDataRedux?.formData?.productTitle})`,
    //   image: { type: "jpeg", quality: 0.98 },
    //   html2canvas: { scale: 2 },
    //   jsPDF: { unit: "mm", format: "a3", orientation: "portrait" },
    //   pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    // };

    // // Generate PDF from the content
    // html2pdf().from(content).set(opt).save();
    // setDisableDownload(false);

    printRfqData();
    setDisableDownload(false);
  };

  const printRfqData = useReactToPrint({
    content: () => rfqContentRef.current,
    documentTitle: "RFQ",
  });
  //end

  const handleClickOpenAddNewCoverage = (Option) => {
    setAddOption(Option);
    setOpenAddNewCoverage(true);
  };

  const handleCloseAddNewCoverage = () => {
    setOpenAddNewCoverage(false);
  };

  const CoverageClauseData = [
    "Add New",
    "HHH jakka",
    "Version 1",
    "Version 3",
    "Vinod",
    "Santosh",
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseInsuranceProviders = () => {
    if (premiumData && premiumData?.length >= 1) {
      setSelectedColumns(() =>
        premiumData
          ?.filter((item) => item?.insuranceProvider !== "Original")
          .map((item) => item?.insuranceProvider)
      );
    }

    setOpen(false);
  };

  const handleMultiSelectChange = (value) => {
    setSelectedColumns(value);
  };

  const handleMultiSelectAdd = () => {
    setColumns([
      "Coverage/Clause",
      "Expiring Terms",
      "Proposed Terms",
      ...selectedColumns,
    ]);

    const finalPremiumData = selectedColumns?.map((item) => {
      return {
        insuranceProvider: item,
        premiumBeforeTax: 0,
        GST18: 0,
        premiumAfterTax: 0,
        stampDuty: 0,
        termsAsProposed: false,
      };
    });

    const nonMatchingRecords = finalPremiumData.filter(
      (finalRecord) =>
        !premiumData.some(
          (premiumRecord) =>
            premiumRecord.insuranceProvider === finalRecord.insuranceProvider
        )
    );

    const uniquePremiumData = premiumData.filter((item) =>
      [...selectedColumns, "Original"].includes(item.insuranceProvider)
    );

    setPremiumData((prevSate) => [...uniquePremiumData, ...nonMatchingRecords]);

    const providers = selectedColumns?.map((item) => {
      return toCamelCase(item);
    });

    const exceptions = [
      "coverage",
      "expiringTermsYesNo",
      "expiringTermsLimitIfAny",
      "proposedTermsLimitIfAny",
      "proposedTermsYesNo",
    ];

    if (providers?.length > 0) {
      setData(filterDataByProviders(data, providers, exceptions));
    }

    handleClose();
  };

  function filterDataByProviders(data, providers, exceptions) {
    return data.map((obj) => {
      const newObj = {};
      Object.keys(obj).forEach((key) => {
        const shouldKeep =
          exceptions.includes(key) ||
          providers.some((provider) => key.startsWith(provider));
        if (shouldKeep) {
          newObj[key] = obj[key];
        }
      });
      return newObj;
    });
  }

  const [premiumData, setPremiumData] = useState<any>([
    {
      insuranceProvider: "Original",
      premiumBeforeTax: 0,
      GST18: 0,
      premiumAfterTax: 0,
      stampDuty: 0,
    },
  ]);

  const [insuranceProviders, setInsuranceProviders] = useState([
    "ICICI Lamboard",
    "Adithya Birla",
    "SBI General",
    "Acko General",
    "Bharati AXA",
  ]);

  const [data, setData] = useState([
    {
      coverage: "",
      expiringTermsYesNo: "",
      expiringTermsLimitIfAny: "",
      proposedTermsYesNo: "",
      proposedTermsLimitIfAny: "",
    },
  ]);

  const [columns, setColumns] = useState([
    "Coverage/Clause",
    "Expiring Terms",
    "Proposed Terms",
  ]);

  const handleYesNoChange = (index, field, value, fieldNext) => {
    setData((prevData) => {
      const newData = [...prevData];
      newData[index][field] = value;
      newData[index][fieldNext] = "";

      return newData;
    });
  };

  const handleSelectChange = (index, field, value) => {
    setData((prevData) => {
      const newData = [...prevData];
      newData[index][field] = value;

      return newData;
    });
  };

  const handlePremiumChange = (index, field, value) => {
    setPremiumData((prevData) => {
      const newData = [...prevData];
      newData[index][field] = parseInt(value);

      if (field === "premiumBeforeTax") {
        const gstAmount = Math.round((value * gstPercentage) / 100);
        newData[index]["GST18"] = gstAmount;
        newData[index]["premiumAfterTax"] =
          parseInt(value) + gstAmount + newData[index]?.stampDuty;
      } else {
        const gstAmount = Math.round(
          (newData[index]?.premiumBeforeTax * gstPercentage) / 100
        );
        newData[index]["GST18"] = gstAmount;
        newData[index]["premiumAfterTax"] =
          parseInt(value) + gstAmount + newData[index]?.premiumBeforeTax;
      }

      return newData;
    });

    // // Add a delay of 5 seconds before sorting
    // setTimeout(() => {
    //   // Sort premiumData based on premiumBeforeTax after the delay
    //   const sortedData = premiumData
    //     .slice(1)
    //     .sort((a, b) => a.premiumBeforeTax - b.premiumBeforeTax);
    //   setPremiumData([premiumData[0], ...sortedData]);

    //   const sortedColumns = sortedData.map((item) => {
    //     return item.insuranceProvider;
    //   });
    //   console.log(sortedColumns);
    //   setColumns([
    //     "Coverage/Clause",
    //     "Expiring Terms",
    //     "Proposed Terms",
    //     ...sortedColumns,
    //   ]);
    // }, 8000); // 8000 milliseconds (8 seconds)
  };

  const handleAddRow = () => {
    setData((prevData) => [
      ...prevData,
      {
        coverage: "",
        expiringTermsYesNo: "",
        expiringTermsLimitIfAny: "",
        proposedTermsYesNo: "",
        proposedTermsLimitIfAny: "",
      },
    ]);
  };

  const handleDeleteRow = async (indexToDelete, data) => {
    setTableLoading(true);
    await setData((prevData) => {
      // Ensure the index is valid
      if (indexToDelete >= 0) {
        // Use filter to exclude the row with the specified index
        return data.filter((_, index) => index !== indexToDelete);
      } else {
        // If the index is invalid, return the previous data
        return data;
      }
    });
    setTableLoading(false);
  };

  function toCamelCase(inputString) {
    // Check if inputString is empty, null, or undefined
    if (!inputString || typeof inputString !== "string") {
      return ""; // Or handle this case based on your requirements
    }

    const words = inputString.split(/\s+/);

    const camelCaseWords = words.map((word, index) => {
      if (index === 0) {
        return word.toLowerCase();
      } else {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
    });

    return camelCaseWords.join("");
  }

  const getCoveragesLimitIfAny = async () => {
    const response = await filterRuntimeFormData(
      PRODUCT_CAVORAGES_LIMITIFANY_FORM_ID,
      "productCode",
      proposalDataRedux?.formData?.productCode
    );
    if (response.success) {
      const responseCoverageClause =
        response?.data[0]?.formData?.coverageClause || []; // default to an empty array if undefined or null
      const responseLimitIfAny = response?.data[0]?.formData?.limitIfAny || []; // default to an empty array if undefined or null
      setCoverages(["Add New", ...responseCoverageClause]);
      setLimitIfAny(["Add New", ...responseLimitIfAny]);
    } else {
      setCoverages(["Add New"]);
      setLimitIfAny(["Add New"]);
    }
  };

  const handleLimitIfAnyField = (column, row, rowIndex) => {
    if (column === "Expiring Terms") {
      return (
        <FormControl className={classes.multiSelect}>
          <Autocomplete
            disableClearable
            disabled={row[toCamelCase(column) + "YesNo"] === "No"}
            componentsProps={{ popper: { style: autoCompleteListStyles } }}
            id={`${column} LimitIfAny`}
            options={[...limitIfAny, ...tempLimitIfAnyList] || []}
            value={row[toCamelCase(column) + "LimitIfAny"]}
            onChange={(_, newValue) =>
              handleSelectChange(
                rowIndex,
                toCamelCase(column) + "LimitIfAny",
                newValue
              )
            }
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                multiline
                inputProps={{
                  ...params.inputProps,
                  className: classes.autocompleteInputStyle,
                }}
              />
            )}
            renderOption={(props, option) =>
              option === "Add New" ? (
                <li>
                  <Button
                    id="add-new-btn"
                    onClick={() =>
                      handleClickOpenAddNewCoverage(
                        ADD_OPTIONS_UNDERWRITER.ADD_LIMITIFANY
                      )
                    }
                    color="primary"
                    startIcon={<AddCircleIcon color="secondary" />}
                  >
                    Add New
                  </Button>
                </li>
              ) : (
                <li {...props} value={option}>
                  {option}
                </li>
              )
            }
          />
        </FormControl>
      );
    } else if (column === "Proposed Terms") {
      return (
        <FormControl className={classes.multiSelect}>
          <Autocomplete
            disableClearable
            disabled={row[toCamelCase(column) + "YesNo"] === "No"}
            componentsProps={{ popper: { style: autoCompleteListStyles } }}
            id={`${column} LimitIfAny`}
            options={[...limitIfAny, ...tempLimitIfAnyList] || []}
            value={row[toCamelCase(column) + "LimitIfAny"]}
            onChange={(_, newValue) =>
              handleSelectChange(
                rowIndex,
                toCamelCase(column) + "LimitIfAny",
                newValue
              )
            }
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                multiline
                inputProps={{
                  ...params.inputProps,
                  className: classes.autocompleteInputStyle,
                }}
              />
            )}
            renderOption={(props, option) =>
              option === "Add New" ? (
                <li>
                  <Button
                    id="add-new-btn"
                    onClick={() =>
                      handleClickOpenAddNewCoverage(
                        ADD_OPTIONS_UNDERWRITER.ADD_LIMITIFANY
                      )
                    }
                    color="primary"
                    startIcon={<AddCircleIcon color="secondary" />}
                  >
                    Add New
                  </Button>
                </li>
              ) : (
                <li {...props} value={option}>
                  {option}
                </li>
              )
            }
          />
        </FormControl>
      );
    } else {
      return (
        <TextField
          id={`${column} LimitIfAny`}
          size="small"
          multiline
          // className={classes.select}
          disabled={row[toCamelCase(column) + "YesNo"] === "No"}
          value={row[toCamelCase(column) + "LimitIfAny"]}
          InputProps={{
            className: classes.textFieldStyles,
          }}
          onChange={(e) =>
            handleSelectChange(
              rowIndex,
              toCamelCase(column) + "LimitIfAny",
              e.target.value
            )
          }
        />
      );
    }
  };

  const handleFormSubmit = async () => {
    setLoading(true);
    const body = {
      formId: proposalDataRedux?.formId,
      id: proposalDataRedux?.id,
      formData: {
        ...proposalDataRedux?.formData,
        underwriterDetails: {
          underwriterData: removeEmptyObjects(data),
          premiumData: premiumData,
          commentsKeyInsights: commentsKeyInsights,
          // rfqDate: rfqDate,
          // qcrDate: qcrDate,
          conditions: {
            isCurrentPolicyInPlace: isCurrentPolicy,
            isStampDuty: isStampDuty,
          },
          taxes: {
            gst: gstPercentage,
          },
        },
        proposalStatus: handleStepStatus(
          proposalDataRedux?.formData?.proposalStatus,
          PROPOSAL_STATUS.QCRDRAFT
        ),
      },
    };
    const response: any = await patchFormData(body);
    if (response?.success) {
      dispatch(
        setProposalData({
          id: body?.id,
          formId: body?.formId,
          formData: body?.formData,
        })
      );
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );
      setLoading(false);
    } else {
      pushNotification({
        isOpen: true,
        type: CONSTANTS.ERROR,
        message: response?.message,
      });
      setLoading(false);
    }
    // handleClickOpenAnchor();
  };

  const handleDataPrefill = () => {
    const newData = [
      ...(proposalDataRedux?.formData?.underwriterDetails?.premiumData?.slice(
        1
      ) || []),
    ];
    let filteredPrefillInsuranceProviders = newData?.map((item) => {
      return item?.insuranceProvider;
    });

    setColumns(
      [
        "Coverage/Clause",
        "Expiring Terms",
        "Proposed Terms",
        ...(filteredPrefillInsuranceProviders || []),
      ] || ["Coverage/Clause", "Expiring Terms", "Proposed Terms"]
    );
    setSelectedColumns(filteredPrefillInsuranceProviders || []);
    setData(
      proposalDataRedux?.formData?.underwriterDetails?.underwriterData || [
        {
          coverage: "",
          expiringTermsYesNo: "",
          expiringTermsLimitIfAny: "",
          proposedTermsYesNo: "",
          proposedTermsLimitIfAny: "",
        },
      ]
    );
    setPremiumData(
      proposalDataRedux?.formData?.underwriterDetails?.premiumData || [
        {
          insuranceProvider: "Original",
          premiumBeforeTax: 0,
          GST18: 0,
          premiumAfterTax: 0,
          stampDuty: 0,
        },
      ]
    );

    setIsCurrentPolicy((prevState) =>
      proposalDataRedux?.formData?.underwriterDetails?.conditions
        ?.isCurrentPolicyInPlace === null ||
      proposalDataRedux?.formData?.underwriterDetails?.conditions
        ?.isCurrentPolicyInPlace === undefined ||
      proposalDataRedux?.formData?.underwriterDetails?.conditions
        ?.isCurrentPolicyInPlace === ""
        ? true
        : proposalDataRedux?.formData?.underwriterDetails?.conditions
            ?.isCurrentPolicyInPlace
    );

    setCommentsKeyInsights(
      proposalDataRedux?.formData?.underwriterDetails?.commentsKeyInsights
    );

    setGstPercentage(
      proposalDataRedux?.formData?.underwriterDetails?.taxes?.gst || 18
    );
    setIsStampDuty(
      proposalDataRedux?.formData?.underwriterDetails?.conditions
        ?.isStampDuty === null ||
        proposalDataRedux?.formData?.underwriterDetails?.conditions
          ?.isStampDuty === undefined ||
        proposalDataRedux?.formData?.underwriterDetails?.conditions
          ?.isStampDuty === ""
        ? false
        : proposalDataRedux?.formData?.underwriterDetails?.conditions
            ?.isStampDuty
    );

    // setRfqDate(proposalDataRedux?.formData?.underwriterDetails?.rfqDate);
    // setQcrDate(proposalDataRedux?.formData?.underwriterDetails?.qcrDate);
  };

  const handleGetProposalCoverageLimitIfAny = async () => {
    const response = await multiFilterRuntimeFormData(
      Proposal_Specific_Coverages_LimitIfany,
      "productCode",
      parseInt(proposalDataRedux?.formData?.productCode),
      "proposalId",
      parseInt(proposalDataRedux?.id)
    );
    if (response.success) {
      setTempCoverageClauseList(
        response?.data[0]?.formData?.coverageClause || []
      );
      setTempLimitIfAnyList(response?.data[0]?.formData?.limitIfAny || []);
    } else {
      setTempCoverageClauseList([]);
      setTempLimitIfAnyList([]);
    }
  };

  const getInsuranceCompanies = async () => {
    const response = await fetchRuntimeFormData(
      INSURANCE_COMPANIES_FORM_ID,
      0,
      10000
    );

    const filteredCompanies = response?.data?.content?.map((item) => {
      return item?.formData?.companyId;
    });

    setInsuranceProviders(filteredCompanies || []);
  };

  const handleStatusChange = async (status) => {
    const body = {
      formId: proposalDataRedux?.formId,
      id: proposalDataRedux?.id,
      formData: {
        proposalStatus: status,
      },
    };
    const response = await patchFormData(body);
    if (response?.success) {
      dispatch(
        setProposalData({
          formId: proposalDataRedux?.formId,
          id: proposalDataRedux?.id,
          formData: {
            ...proposalDataRedux?.formData,
            proposalStatus: status,
          },
        })
      );
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );
    } else {
      pushNotification({
        isOpen: true,
        type: CONSTANTS.ERROR,
        message: response?.message,
      });
    }
  };

  const handleStampDutyOff = (isStampDuty) => {
    if (!isStampDuty) {
      const modifiedPremiums = premiumData?.map((item) => {
        return {
          ...item,
          stampDuty: 0,
          premiumAfterTax: item?.premiumAfterTax - item?.stampDuty,
        };
      });
      setPremiumData(modifiedPremiums);
    }
  };

  const handleIsStampDutyClick = (e: any) => {
    setIsStampDuty(e.target.checked);
    handleStampDutyOff(e.target.checked);
  };

  const handleGSTPremiumChange = (value) => {
    if (!premiumData) return; // Check if premiumData is not null or undefined

    const modifiedPremiums = premiumData?.map((item) => {
      const GST18 = Math.round((item?.premiumBeforeTax * value) / 100);
      const premiumAfterTax = item?.stampDuty
        ? item?.premiumBeforeTax + GST18 + item?.stampDuty
        : item?.premiumBeforeTax + GST18;

      return {
        ...item,
        GST18,
        premiumAfterTax,
      };
    });

    setPremiumData(modifiedPremiums);
  };

  const handleGstChange = (e) => {
    setGstPercentage(parseInt(e.target.value));
    handleGSTPremiumChange(e.target.value);
  };

  const handleCurrentPolicyOff = (isCurrentPolicy) => {
    if (!isCurrentPolicy) {
      const modifiedUnderwriterData = data?.map((item) => {
        return {
          ...item,
          expiringTermsLimitIfAny: "",
          expiringTermsYesNo: "",
        };
      });
      setData(modifiedUnderwriterData);
    }
  };

  const handleIsCurrentPolicyClick = (e: any) => {
    setIsCurrentPolicy(e.target.checked);
    handleCurrentPolicyOff(e.target.checked);
  };

  // Logic to find empty objects in a array

  const removeEmptyObjects = (arr) => {
    return arr.filter((obj) => {
      for (let key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] !== "") {
          return true;
        }
      }
      return false;
    });
  };

  //end

  // Logic to handle Terms As Proposed

  const handleTermsAsProposed = (column, index) => {
    switch (column) {
      case "Coverage/Clause":
        return "In-Built Covers / Add-on Covers / Conditions";
      case "Expiring Terms":
        return null;
      case "Proposed Terms":
        return null;
      default:
        return (
          <div>
            Terms As Proposed{" "}
            <Switch
              checked={premiumData[index - 2]?.termsAsProposed || false}
              onChange={(e) => handleOnchangeTermsAsProposed(e, index)}
              size="small"
            />
          </div>
        );
    }
  };

  const handleOnchangeTermsAsProposed = (e, index) => {
    setPremiumData((prevState) => {
      const newArray = [...prevState];
      newArray[index - 2] = {
        ...prevState[index - 2],
        termsAsProposed: e.target.checked,
      };
      return newArray;
    });
    if (e.target.checked) {
      mappingProposedTermsToInsuranceCompanyTerms(
        premiumData[index - 2].insuranceProvider
      );
    }
  };

  const mappingProposedTermsToInsuranceCompanyTerms = async (
    insuranceCompany
  ) => {
    console.log(insuranceCompany);
    const formmatedUnderWriterData = data?.map((item, index) => {
      return {
        ...item,
        [toCamelCase(insuranceCompany) + "YesNo"]: item?.proposedTermsYesNo,
        [toCamelCase(insuranceCompany) + "LimitIfAny"]:
          item?.proposedTermsLimitIfAny,
      };
    });
    console.log(formmatedUnderWriterData);
    await setData(formmatedUnderWriterData);
  };

  //End

  useEffect(() => {
    if (!proposalDataRedux?.formId) {
      navigate(`${process.env.PUBLIC_URL}/proposalList`);
    }
  }, []);

  useEffect(() => {
    getCoveragesLimitIfAny();
    handleGetProposalCoverageLimitIfAny();
  }, [refresh]);

  useEffect(() => {
    handleDataPrefill();
    getInsuranceCompanies();
  }, []);

  return (
    <div className={classes.underwriterContainer}>
      <div className={classes.drawerBtn}>
        <Tooltip title={"Underwriter Panel"}>
          <IconButton onClick={handleClickOpenAnchor} size="small">
            {openAnchor ? (
              <ArrowForwardIosIcon
                className={classes.drawerIcon}
                fontSize="small"
              />
            ) : (
              <ArrowBackIosIcon
                className={classes.drawerIcon}
                fontSize="small"
              />
            )}
          </IconButton>
        </Tooltip>
      </div>
      <Drawer
        className={classes.underwriterDrawer}
        anchor={"right"}
        open={openAnchor}
        onClose={handleClickCloseAnchor}
      >
        <CommentsKeyInsights
          commentsKeyInsights={commentsKeyInsights}
          setCommentsKeyInsights={setCommentsKeyInsights}
        />

        <div className={classes.underwriterPanelActions}>
          <label className={classes.underwriterPanelActionsHeading}>
            Actions
          </label>
          <div className={classes.flexRowDrawerBtns}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.saveButton}
              onClick={handleFormSubmit}
              startIcon={<SaveIcon fontSize="small" />}
              size="small"
            >
              Save Details
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.previewButton}
              onClick={() =>
                handlePreviewButtonClick(PREVIEW_ENUMS.PREVIEW_RFQ)
              }
            >
              RFQ Preview
            </Button>

            <Button
              variant="contained"
              color="primary"
              className={classes.previewButton}
              onClick={() =>
                handlePreviewButtonClick(PREVIEW_ENUMS.PREVIEW_QCR)
              }
              disabled={
                !Boolean(
                  Object.keys(
                    proposalDataRedux?.formData?.underwriterDetails?.premiumData
                      ? proposalDataRedux?.formData?.underwriterDetails
                          ?.premiumData
                      : {}
                  )?.length > 1
                )
              }
            >
              QCR Preview
            </Button>
          </div>
        </div>
      </Drawer>
      <Dialog
        onClose={handleCloseGenerate}
        aria-labelledby="customized-dialog-generate"
        open={openGenerate}
        className={classes.customDialog}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-generate">
          {generate === GENERATE_ENUMS.GENERATE_RFQ ? "RFQ Email" : "QCR Email"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseGenerate}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <GenerateRFQQCR
          generate={generate}
          setOpenGenerate={setOpenGenerate}
          contentRef={
            generate === GENERATE_ENUMS.GENERATE_RFQ
              ? rfqContentRef
              : qcrContentRef
          }
        />
      </Dialog>

      <Dialog
        onClose={handleClosePreview}
        aria-labelledby="customized-dialog-preview"
        open={openPreview}
        className={classes.customDialog}
        fullWidth
      >
        <DialogTitle
          className={classes.previewDialogHeading}
          id="customized-dialog-preview"
        >
          {preview === PREVIEW_ENUMS.PREVIEW_RFQ
            ? "RFQ Preview"
            : "QCR Preview"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClosePreview}
          className={classes.previewCloseBtn}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {preview === PREVIEW_ENUMS.PREVIEW_RFQ ? (
            <RFQPreview rfqContentRef={rfqContentRef} />
          ) : (
            <QCRPreview qcrContentRef={qcrContentRef} />
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            variant="outlined"
            color="primary"
            className={classes.commonBtnStyles}
            onClick={handlePreviewDownload}
            disabled={disableDownload}
          >
            Download
          </Button>

          {/* {preview === PREVIEW_ENUMS.PREVIEW_RFQ ? (
            <Button
              variant="outlined"
              color="primary"
              className={classes.commonBtnStyles}
              onClick={() =>
                handleGenerateButtonClick(GENERATE_ENUMS.GENERATE_RFQ)
              }
            >
              RFQ Email
            </Button>
          ) : (
            <Button
              variant="outlined"
              color="primary"
              className={classes.commonBtnStyles}
              onClick={() =>
                handleGenerateButtonClick(GENERATE_ENUMS.GENERATE_QCR)
              }
            >
              QCR Email
            </Button>
          )} */}
        </DialogActions>
      </Dialog>

      <Dialog
        // fullScreen={fullScreen}
        open={openAddNewCoverage}
        onClose={handleCloseAddNewCoverage}
        aria-labelledby="responsive-dialog-Coverage"
      >
        <AddCoverageClause
          openAddNewCoverage={openAddNewCoverage}
          setOpenAddNewCoverage={setOpenAddNewCoverage}
          addOption={addOption}
          setRefresh={setRefresh}
        />
      </Dialog>

      <Dialog
        // fullScreen={fullScreen}
        open={open}
        onClose={handleCloseInsuranceProviders}
        aria-labelledby="responsive-dialog-company"
      >
        <DialogTitle id="responsive-dialog-company">
          {"Please Select the Insurance Providers To Add"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <FormControl className={classes.multiSelect}>
              <Autocomplete
                multiple
                disableClearable
                id="insurance-providers-autocomplete"
                options={insuranceProviders}
                value={selectedColumns}
                onChange={(_, newValue) => handleMultiSelectChange(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    inputProps={{
                      ...params.inputProps,
                      className: classes.autocompleteInputStyle,
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <MenuItem {...props} value={option}>
                    {option}
                  </MenuItem>
                )}
              />
            </FormControl>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleMultiSelectAdd}
            autoFocus
          >
            Add Selected Insurance Providers
          </Button>
          <Button
            variant="outlined"
            color="primary"
            autoFocus
            onClick={handleCloseInsuranceProviders}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <div className={classes.underwriterDetailsHeadingText}>Underwriter</div>

      <div className={classes.tableContainer}>
        {/* <div className={classes.underwriterDetailsHeadingText}>
          <Tooltip title="Back">
            <IconButton
              onClick={() =>
                navigate(`${process.env.PUBLIC_URL}/createProposal`)
              }
              color="primary"
            >
              <ArrowBackIosIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          Underwriter Details
        </div> */}
        <TableContainer className={classes.tableContainerStyles}>
          <Table className={classes.table} stickyHeader>
            <TableHead className={classes.stickyHead}>
              {/* <TableRow>
                <TableCell className={`${classes.th} ${classes.firstColumn}`}>
                  <div className={classes.flexColumn}>
                    <div className={classes.dateConatiner}>
                      <div>RFQ Date</div>
                      <div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={rfqDate}
                            onChange={(newValue) => {
                              setRfqDate(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                inputProps={{
                                  ...params.inputProps,
                                  placeholder: "DD/MM/YYYY",
                                  className: classes.inputStylesDate,
                                }}
                                size="small"
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                    <div className={classes.dateConatiner}>
                      <div>QCR Date</div>
                      <div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={qcrDate}
                            onChange={(newValue) => {
                              setQcrDate(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                inputProps={{
                                  ...params.inputProps,
                                  placeholder: "DD/MM/YYYY",
                                  className: classes.inputStylesDate,
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                  </div>
                </TableCell>
              </TableRow> */}

              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    className={`${classes.insuredNameCell} ${
                      index === 0 && classes.stickyHeadColumn
                    }`}
                    sx={{
                      display: index === 1 && !isCurrentPolicy ? "none" : "",
                    }}
                  >
                    {column}
                  </TableCell>
                ))}
                <TableCell className={classes.emptyCell}></TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className={`${classes.th} ${classes.stickyHeadColumn}`}
                >
                  <div className={classes.flexColumnPremiumLabels}>
                    <div>Premium Before Tax</div>
                    {isStampDuty && <div>Stamp Duty</div>}
                    <div>
                      GST @{" "}
                      <select
                        className={classes.gstSelect}
                        value={gstPercentage}
                        onChange={handleGstChange}
                      >
                        <option value={18}>18</option>
                        <option value={12}>12</option>
                        <option value={9}>9</option>
                        <option value={0}>0</option>
                      </select>
                    </div>
                    <div>Premium After Tax</div>
                  </div>
                </TableCell>

                {premiumData?.map((item, index) => (
                  <>
                    <TableCell
                      className={classes.th}
                      sx={{
                        display: index === 0 && !isCurrentPolicy ? "none" : "",
                      }}
                    >
                      <div className={classes.flexColumn}>
                        <div>
                          <TextField
                            id="Premium Before Tax"
                            name="premiumBeforeTax"
                            size="small"
                            type="number"
                            value={
                              item["premiumBeforeTax"] === 0
                                ? null
                                : item["premiumBeforeTax"]
                            }
                            onChange={(e) =>
                              handlePremiumChange(
                                index,
                                e.target.name,
                                e.target.value
                              )
                            }
                            InputProps={{
                              className: classes.textFieldStyles,
                              startAdornment: (
                                <InputAdornment position="start">
                                  ₹
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                        {isStampDuty && (
                          <div>
                            <TextField
                              id="stamp-duty"
                              name="stampDuty"
                              size="small"
                              type="number"
                              value={
                                item["stampDuty"] === 0
                                  ? null
                                  : item["stampDuty"]
                              }
                              onChange={(e) =>
                                handlePremiumChange(
                                  index,
                                  e.target.name,
                                  e.target.value
                                )
                              }
                              InputProps={{
                                className: classes.textFieldStyles,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    ₹
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        )}

                        <div>
                          <TextField
                            disabled
                            id="GST @18%"
                            name="GST18"
                            size="small"
                            type="number"
                            value={item["GST18"]}
                            // onChange={(e) =>
                            //   handlePremiumChange(
                            //     index,
                            //     e.target.name,
                            //     e.target.value
                            //   )
                            // }
                            InputProps={{
                              className: classes.textFieldStyles,
                              startAdornment: (
                                <InputAdornment position="start">
                                  ₹
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                        <div>
                          <TextField
                            disabled
                            id="Premium After Tax"
                            name="premiumAfterTax"
                            size="small"
                            type="number"
                            value={item["premiumAfterTax"]}
                            // onChange={(e) =>
                            //   handlePremiumChange(
                            //     index,
                            //     e.target.name,
                            //     e.target.value
                            //   )
                            // }
                            InputProps={{
                              className: classes.textFieldStyles,
                              startAdornment: (
                                <InputAdornment position="start">
                                  ₹
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                      </div>
                    </TableCell>
                    {index === 0 ? (
                      <TableCell className={classes.th}>
                        <div>
                          Is there a current policy in place?{" "}
                          <Switch
                            checked={isCurrentPolicy}
                            onChange={(e) => handleIsCurrentPolicyClick(e)}
                            size="small"
                          />
                        </div>
                        <div>
                          Stamp Duty{" "}
                          <Switch
                            checked={isStampDuty}
                            onChange={handleIsStampDutyClick}
                            size="small"
                          />
                        </div>
                      </TableCell>
                    ) : null}
                  </>
                ))}
                <TableCell className={classes.emptyCell}></TableCell>
              </TableRow>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    key={index}
                    className={`${classes.th} ${
                      index === 0 && classes.stickyHeadColumn
                    }`}
                    sx={{
                      display:
                        column === "Expiring Terms" && !isCurrentPolicy
                          ? "none"
                          : "",
                    }}
                  >
                    <div>
                      {" "}
                      {/* {column === "Coverage/Clause"
                        ? "In-Built Covers / Add-on Covers / Conditions"
                        : null} */}
                      {handleTermsAsProposed(column, index)}
                    </div>
                    {column !== "Coverage/Clause" ? (
                      <div className={classes.flexRow}>
                        <div>{"YES/NO"}</div>
                        <div>{"LIMIT IF ANY"}</div>
                      </div>
                    ) : null}
                  </TableCell>
                ))}
                <TableCell className={classes.emptyCell}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableLoading ? (
                <TableRow></TableRow>
              ) : (
                <>
                  {data?.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {columns.map((column, colIndex) => (
                        <TableCell
                          key={colIndex}
                          className={
                            colIndex === 0
                              ? `${classes.td} ${classes.fixedColumn}`
                              : classes.td
                          }
                          sx={{
                            display:
                              column === "Expiring Terms" && !isCurrentPolicy
                                ? "none"
                                : "",
                          }}
                        >
                          {column === "Coverage/Clause" ? (
                            <FormControl className={classes.multiSelect}>
                              <Autocomplete
                                disableClearable
                                componentsProps={{
                                  popper: {
                                    style: autoCompleteListStyles,
                                  },
                                }}
                                id="insurance-providers-autocomplete"
                                getOptionDisabled={(option) => {
                                  // Check if any item in the data array matches the condition
                                  return data?.some(
                                    (item) => item?.coverage === option
                                  );
                                }}
                                options={
                                  [...coverages, ...tempCoverageClauseList] ||
                                  []
                                }
                                value={row.coverage}
                                onChange={(_, newValue) =>
                                  handleSelectChange(
                                    rowIndex,
                                    "coverage",
                                    newValue
                                  )
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    multiline
                                    inputProps={{
                                      ...params.inputProps,
                                      className: classes.autocompleteInputStyle,
                                    }}
                                  />
                                )}
                                renderOption={(props, option) =>
                                  option === "Add New" ? (
                                    <li>
                                      <Button
                                        id="add-new-btn"
                                        onClick={() =>
                                          handleClickOpenAddNewCoverage(
                                            ADD_OPTIONS_UNDERWRITER.ADD_COVERAGECLAUSE
                                          )
                                        }
                                        color="primary"
                                        startIcon={
                                          <AddCircleIcon color="secondary" />
                                        }
                                      >
                                        Add New
                                      </Button>
                                    </li>
                                  ) : (
                                    <li {...props} value={option}>
                                      {option}
                                    </li>
                                  )
                                }
                              />
                            </FormControl>
                          ) : (
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Select
                                  key={rowIndex}
                                  id={`select${rowIndex}`}
                                  size="small"
                                  className={classes.select}
                                  value={
                                    row[toCamelCase(column) + "YesNo"] || ""
                                  }
                                  onChange={(e) =>
                                    handleYesNoChange(
                                      rowIndex,
                                      toCamelCase(column) + "YesNo",
                                      e.target.value,
                                      toCamelCase(column) + "LimitIfAny"
                                    )
                                  }
                                >
                                  <MenuItem value=""></MenuItem>
                                  <MenuItem value="Yes">Yes</MenuItem>
                                  <MenuItem value="No">No</MenuItem>
                                </Select>
                              </Grid>
                              <Grid item xs={6}>
                                {handleLimitIfAnyField(column, row, rowIndex)}
                              </Grid>
                            </Grid>
                          )}
                        </TableCell>
                      ))}
                      {data?.length > 1 ? (
                        <TableCell className={classes.deleteTableCell}>
                          <IconButton
                            onClick={() => handleDeleteRow(rowIndex, data)}
                          >
                            <DeleteIcon color="secondary" />
                          </IconButton>
                        </TableCell>
                      ) : null}
                    </TableRow>
                  ))}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {loading ? (
        <Box className={classes.loader}>
          <Lottie
            animationData={DotLoader}
            loop={true}
            style={animationStyle}
          />
          {/* <CircularProgress size={80} />
          ...Please Wait */}
        </Box>
      ) : (
        <div className={classes.btnContainer}>
          <Button
            variant="contained"
            color="primary"
            className={classes.backButton}
            onClick={() => navigate(`${process.env.PUBLIC_URL}/createProposal`)}
            startIcon={<NavigateBeforeIcon fontSize="small" />}
            size="small"
          >
            Back
          </Button>
          <Button
            variant="outlined"
            color="primary"
            className={classes.addButton}
            onClick={handleAddRow}
            startIcon={<AddCircleOutlineIcon fontSize="small" />}
            size="small"
          >
            Add Row
          </Button>
          <Button
            variant="outlined"
            color="primary"
            className={classes.addButton}
            onClick={handleClickOpen}
            startIcon={<BusinessIcon fontSize="small" />}
            size="small"
          >
            Add/Remove Insurance Provider
          </Button>
          <Button
            variant="outlined"
            color="primary"
            className={classes.addButton}
            onClick={handleFormSubmit}
            startIcon={<SaveIcon fontSize="small" />}
            size="small"
          >
            Save Details
          </Button>
        </div>
      )}
    </div>
  );
};

export default UnderwriterDetails;
